module.exports = __webpack_public_path__ + "img/positive_cold.0145dc4c.png";